<template>
  <div>
    <template v-for="item in menuList">
      <!-- 有次级菜单的,则展开子选项-->
      <el-submenu
        v-if="item.children && item.children.length > 0"
        :key="item.id"
        :index="item.id"
      >
        <template #title>
          <i v-if="item.icon" :class="item.icon" :title="item.name"></i>
          <span>{{ item.name }}</span>
        </template>
        <!-- 递归,实现无限级展开 -->
        <side-bar :menuList="item.children"></side-bar>
      </el-submenu>
      <!-- 没有次级菜单的 -->
      <el-menu-item v-if="!item.children" :key="item.id" :index="item.url">
        <i v-if="item.icon" :class="item.icon" :title="item.name"></i>
        <span>{{ item.name }}</span>
      </el-menu-item>
    </template>
  </div>
</template>

<script>
export default {
  name: "sideBar",
  components: {},
  props: {
    menuList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  methods: {},
  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped></style>
